/* tslint:disable */
export class LocaleKeys {
    constructor(private translate: Function) {
        //
    }

    public THANK_YOU_PAGE_PLAN_DURATION_DESCRIPTION_SINGULAR = (options: { frequencyUnitSingular: any }) => this.translate('THANK_YOU_PAGE_PLAN_DURATION_DESCRIPTION_SINGULAR', options) /* 1 {{frequencyUnitSingular}} subscription */;
    public thankYouPage = {
        pricingPlans: {
            frequency: {
                years: {
                    plural: () => this.translate('thankYouPage.pricingPlans.frequency.years.plural') /* years */,
                },
                day: {
                    singular: () => this.translate('thankYouPage.pricingPlans.frequency.day.singular') /* day */,
                },
                month: {
                    singular: () => this.translate('thankYouPage.pricingPlans.frequency.month.singular') /* month */,
                },
                months: {
                    plural: () => this.translate('thankYouPage.pricingPlans.frequency.months.plural') /* months */,
                },
                weeks: {
                    plural: () => this.translate('thankYouPage.pricingPlans.frequency.weeks.plural') /* weeks */,
                },
                year: {
                    singular: () => this.translate('thankYouPage.pricingPlans.frequency.year.singular') /* year */,
                },
                days: {
                    plural: () => this.translate('thankYouPage.pricingPlans.frequency.days.plural') /* days */,
                },
                week: {
                    singular: () => this.translate('thankYouPage.pricingPlans.frequency.week.singular') /* week */,
                },
            },
            startDate: {
                label: (options: { date: any }) => this.translate('thankYouPage.pricingPlans.startDate.label', options) /* Start date: {{date}} */,
            },
            afterFreeTrial: {
                label: () => this.translate('thankYouPage.pricingPlans.afterFreeTrial.label') /* After free trial */,
            },
            freeTrial: {
                label: (options: { number: any, frequency: any }) => this.translate('thankYouPage.pricingPlans.freeTrial.label', options) /* Free trial: {{number}} {{frequency}} */,
            },
            duration: {
                untilCanceled: () => this.translate('thankYouPage.pricingPlans.duration.untilCanceled') /* Until canceled */,
                label: (options: { number: any, frequency: any }) => this.translate('thankYouPage.pricingPlans.duration.label', options) /* Duration: {{number}} {{frequency}} */,
            },
        },
        paymentMethod: {
            multipleMethods: {
                label: (options: { paymentMethod1: any, paymentMethod2: any }) => this.translate('thankYouPage.paymentMethod.multipleMethods.label', options) /* {{paymentMethod1}}, {{paymentMethod2}} */,
            },
            label: () => this.translate('thankYouPage.paymentMethod.label') /* Payment method */,
        },
        pendingOrder: {
            title: {
                withName: (options: { name: any }) => this.translate('thankYouPage.pendingOrder.title.withName', options) /* Thank you, {{name}} */,
            },
            body: (options: { buyerEmail: any }) => this.translate('thankYouPage.pendingOrder.body', options) /* Your order is being processed. We'll send an order confirmation to {{buyerEmail}} if it's approved. */,
        },
        taxExemption: {
            partial: {
                label: () => this.translate('thankYouPage.taxExemption.partial.label') /* Tax exemption */,
            },
            full: {
                label: (options: { name: any }) => this.translate('thankYouPage.taxExemption.full.label', options) /* {{name}} (Exempt) */,
            },
        },
        address: {
            addressLine1addressLine2CitySubdivisionCountry: (options: { addressLine1: any, addressLine2: any, city: any, subdivision: any, country: any }) => this.translate('thankYouPage.address.addressLine1addressLine2CitySubdivisionCountry', options) /* {{addressLine1}}, {{addressLine2}}
{{city}}, {{subdivision}}, {{country}} */,
            addressLine1addressLine2Country: (options: { addressLine1: any, addressLine2: any, country: any }) => this.translate('thankYouPage.address.addressLine1addressLine2Country', options) /* {{addressLine1}}, {{addressLine2}}
{{country}} */,
            defaultText: () => this.translate('thankYouPage.address.defaultText') /* Street, City, State
Zip Code, Country */,
            addressLine1addressLine2PostalCodeCountry: (options: { addressLine1: any, addressLine2: any, postalCode: any, country: any }) => this.translate('thankYouPage.address.addressLine1addressLine2PostalCodeCountry', options) /* {{addressLine1}}, {{addressLine2}}
{{postalCode}}, {{country}} */,
            cityPostalCodeCountry: (options: { city: any, postalCode: any, country: any }) => this.translate('thankYouPage.address.cityPostalCodeCountry', options) /* {{city}}, {{postalCode}}, {{country}} */,
            addressLine1CityPostalCodeCountry: (options: { addressLine1: any, city: any, postalCode: any, country: any }) => this.translate('thankYouPage.address.addressLine1CityPostalCodeCountry', options) /* {{addressLine1}}
{{city}}, {{postalCode}}, {{country}} */,
            addressLine1addressLine2CityPostalCodeCountry: (options: { addressLine1: any, addressLine2: any, city: any, postalCode: any, country: any }) => this.translate('thankYouPage.address.addressLine1addressLine2CityPostalCodeCountry', options) /* {{addressLine1}}, {{addressLine2}}
{{city}}, {{postalCode}}, {{country}} */,
            addressLine1addressLine2CitySubdivisionPostalCodeCountry: (options: { addressLine1: any, addressLine2: any, city: any, subdivision: any, postalCode: any, country: any }) => this.translate('thankYouPage.address.addressLine1addressLine2CitySubdivisionPostalCodeCountry', options) /* {{addressLine1}}, {{addressLine2}}
{{city}}, {{subdivision}} {{postalCode}}, {{country}} */,
            postalCodeCountry: (options: { postalCode: any, country: any }) => this.translate('thankYouPage.address.postalCodeCountry', options) /* {{postalCode}}, {{country}} */,
            addressLine1addressLine2CityCountry: (options: { addressLine1: any, addressLine2: any, city: any, country: any }) => this.translate('thankYouPage.address.addressLine1addressLine2CityCountry', options) /* {{addressLine1}}, {{addressLine2}}
{{city}}, {{country}} */,
            addressLine1PostalCodeCountry: (options: { addressLine1: any, postalCode: any, country: any }) => this.translate('thankYouPage.address.addressLine1PostalCodeCountry', options) /* {{addressLine1}}
{{postalCode}}, {{country}} */,
            citySubdivisionPostalCodeCountry: (options: { city: any, subdivision: any, postalCode: any, country: any }) => this.translate('thankYouPage.address.citySubdivisionPostalCodeCountry', options) /* {{city}}, {{subdivision}} {{postalCode}}, {{country}} */,
            addressLine1CityCountry: (options: { addressLine1: any, city: any, country: any }) => this.translate('thankYouPage.address.addressLine1CityCountry', options) /* {{addressLine1}}
{{city}}, {{country}} */,
            subdivisionCountry: (options: { subdivision: any, country: any }) => this.translate('thankYouPage.address.subdivisionCountry', options) /* {{subdivision}}, {{country}} */,
            subdivisionPostalCodeCountry: (options: { subdivision: any, postalCode: any, country: any }) => this.translate('thankYouPage.address.subdivisionPostalCodeCountry', options) /* {{subdivision}} {{postalCode}}, {{country}} */,
            country: (options: { country: any }) => this.translate('thankYouPage.address.country', options) /* {{country}} */,
            citySubdivisionCountry: (options: { city: any, subdivision: any, country: any }) => this.translate('thankYouPage.address.citySubdivisionCountry', options) /* {{city}}, {{subdivision}}, {{country}} */,
            addressLine1CitySubdivisionCountry: (options: { addressLine1: any, city: any, subdivision: any, country: any }) => this.translate('thankYouPage.address.addressLine1CitySubdivisionCountry', options) /* {{addressLine1}}
{{city}}, {{subdivision}}, {{country}} */,
            addressLine1Country: (options: { addressLine1: any, country: any }) => this.translate('thankYouPage.address.addressLine1Country', options) /* {{addressLine1}}
{{country}} */,
            cityCountry: (options: { city: any, country: any }) => this.translate('thankYouPage.address.cityCountry', options) /* {{city}}, {{country}} */,
            addressLine1CitySubdivisionPostalCodeCountry: (options: { addressLine1: any, city: any, subdivision: any, postalCode: any, country: any }) => this.translate('thankYouPage.address.addressLine1CitySubdivisionPostalCodeCountry', options) /* {{addressLine1}}
{{city}}, {{subdivision}} {{postalCode}}, {{country}} */,
        },
        paid: {
            label: () => this.translate('thankYouPage.paid.label') /* Paid */,
        },
        errorPage: {
            error: {
                title: () => this.translate('thankYouPage.errorPage.error.title') /* This page can't be accessed */,
                body: () => this.translate('thankYouPage.errorPage.error.body') /* Make sure you’re logged in to the right account, or check the URL and try again. */,
            },
        },
        textTab: {
            paymentMethodDefaultText: () => this.translate('thankYouPage.textTab.paymentMethodDefaultText') /* Payment method */,
            platformizedShippingAddressDefaultText: () => this.translate('thankYouPage.textTab.platformizedShippingAddressDefaultText') /* Delivery address */,
            subscription: {
                subscriptionPlanLabel: {
                    label: () => this.translate('thankYouPage.textTab.subscription.subscriptionPlanLabel.label') /* Subscription label */,
                    defaultText: () => this.translate('thankYouPage.textTab.subscription.subscriptionPlanLabel.defaultText') /* Subscription */,
                },
                title: {
                    defaultText: () => this.translate('thankYouPage.textTab.subscription.title.defaultText') /* Thanks for subscribing! */,
                    $value: () => this.translate('thankYouPage.textTab.subscription.title') /* Subscription title */,
                },
                subtitle: {
                    $value: () => this.translate('thankYouPage.textTab.subscription.subtitle') /* Subscription subtitle */,
                    defaultText: () => this.translate('thankYouPage.textTab.subscription.subtitle.defaultText') /* You'll receive a confirmation email soon. */,
                },
            },
            paymentMethodLabel: () => this.translate('thankYouPage.textTab.paymentMethodLabel') /* Payment method label */,
            platformizedTitleDefaultLabel: () => this.translate('thankYouPage.textTab.platformizedTitleDefaultLabel') /* Thank you! */,
            linkHeader: () => this.translate('thankYouPage.textTab.linkHeader') /* Continue Browsing link */,
            billingAddressLabel: () => this.translate('thankYouPage.textTab.billingAddressLabel') /* Billing address label */,
            billingAddressDefaultText: () => this.translate('thankYouPage.textTab.billingAddressDefaultText') /* Billing address */,
        },
        giftCards: {
            label: () => this.translate('thankYouPage.giftCards.label') /* Gift cards */,
        },
        totals: {
            subscriptions: {
                showMore: () => this.translate('thankYouPage.totals.subscriptions.showMore') /* Show More */,
                pricingPlanProjectionWithMore: (options: { itemName: any, remainingCount: any, chargesDescription: any }) => this.translate('thankYouPage.totals.subscriptions.pricingPlanProjectionWithMore', options) /* {{itemName}} and {{remainingCount}} more - {{chargesDescription}} */,
                pricingPlanProjection: (options: { itemName: any, chargesDescription: any }) => this.translate('thankYouPage.totals.subscriptions.pricingPlanProjection', options) /* {{itemName}} - {{chargesDescription}} */,
                showLess: () => this.translate('thankYouPage.totals.subscriptions.showLess') /* Show Less */,
            },
        },
        dueLater: {
            label: () => this.translate('thankYouPage.dueLater.label') /* Due later */,
        },
        salesTax: {
            label: () => this.translate('thankYouPage.salesTax.label') /* Sales tax */,
        },
        modifiers: {
            moreHidden: (options: { count: any }) => this.translate('thankYouPage.modifiers.moreHidden', options) /* and {{count}} more */,
            modifierDetails: {
                price: (options: { modifierName: any, price: any }) => this.translate('thankYouPage.modifiers.modifierDetails.price', options) /* {{modifierName}} ({{price}}) */,
                quantity: (options: { quantity: any, modifierName: any }) => this.translate('thankYouPage.modifiers.modifierDetails.quantity', options) /* {{quantity}}x {{modifierName}} */,
                other: (options: { modifierName: any }) => this.translate('thankYouPage.modifiers.modifierDetails.other', options) /* {{modifierName}} */,
                quantityAndPrice: (options: { quantity: any, modifierName: any, price: any }) => this.translate('thankYouPage.modifiers.modifierDetails.quantityAndPrice', options) /* {{quantity}}x {{modifierName}} ({{price}}) */,
            },
            categoryLabel: (options: { categoryName: any }) => this.translate('thankYouPage.modifiers.categoryLabel', options) /* {{categoryName}}: */,
        },
        shipping: {
            label: () => this.translate('thankYouPage.shipping.label') /* Delivery */,
        },
        phoneNumber: {
            defaultText: () => this.translate('thankYouPage.phoneNumber.defaultText') /* Phone number */,
        },
        shippingAddress: {
            label: () => this.translate('thankYouPage.shippingAddress.label') /* Delivery address */,
        },
        designTab: {
            general: {
                headerTextFontColor: () => this.translate('thankYouPage.designTab.general.headerTextFontColor') /* Header Text Font & Color */,
                $value: () => this.translate('thankYouPage.designTab.general') /* General */,
            },
            continueBrowsingLink: {
                $value: () => this.translate('thankYouPage.designTab.continueBrowsingLink') /* Continue Browsing link */,
                continueBrowsingLink: () => this.translate('thankYouPage.designTab.continueBrowsingLink.continueBrowsingLink') /* Continue Browsing Link */,
            },
            pageBackground: () => this.translate('thankYouPage.designTab.pageBackground') /* Page background */,
            pageBackgroundlabel: () => this.translate('thankYouPage.designTab.pageBackgroundlabel') /* Page background opacity & color */,
            itemDetails: () => this.translate('thankYouPage.designTab.itemDetails') /* Item details */,
            orderOverview: () => this.translate('thankYouPage.designTab.orderOverview') /* Order overview */,
            items: {
                items: () => this.translate('thankYouPage.designTab.items.items') /* Items */,
                $value: () => this.translate('thankYouPage.designTab.items') /* Items */,
                totals: () => this.translate('thankYouPage.designTab.items.totals') /* Totals */,
            },
            cardBackground: () => this.translate('thankYouPage.designTab.cardBackground') /* Cards background */,
            cardBackgroundlabel: () => this.translate('thankYouPage.designTab.cardBackgroundlabel') /* Cards background opacity & color */,
            links: () => this.translate('thankYouPage.designTab.links') /* Links */,
        },
        addressFormat: {
            line2: {
                withSubdivision: (options: { addressLine1: any, addressLine2: any, city: any, subdivision: any, zipCode: any, country: any }) => this.translate('thankYouPage.addressFormat.line2.withSubdivision', options) /* {{addressLine1}}, {{addressLine2}}
{{city}}, {{subdivision}} {{zipCode}}, {{country}} */,
                withoutSubdivision: (options: { addressLine1: any, addressLine2: any, city: any, zipCode: any, country: any }) => this.translate('thankYouPage.addressFormat.line2.withoutSubdivision', options) /* {{addressLine1}}, {{addressLine2}}
{{city}}, {{zipCode}}, {{country}} */,
            },
            line1: {
                withoutSubdivision: (options: { addressLine1: any, city: any, zipCode: any, country: any }) => this.translate('thankYouPage.addressFormat.line1.withoutSubdivision', options) /* {{addressLine1}}
{{city}}, {{zipCode}}, {{country}} */,
                withSubdivision: (options: { addressLine1: any, city: any, subdivision: any, zipCode: any, country: any }) => this.translate('thankYouPage.addressFormat.line1.withSubdivision', options) /* {{addressLine1}}
{{city}}, {{subdivision}} {{zipCode}}, {{country}} */,
            },
        },
        deliveryMethod: {
            free: {
                label: () => this.translate('thankYouPage.deliveryMethod.free.label') /* Free */,
            },
        },
        giftCardDelay: {
            errorMessage: () => this.translate('thankYouPage.giftCardDelay.errorMessage') /* We’re experiencing some delays, so it might take longer than usual to send your gift card. Thank you for your patience. */,
        },
        subtitle: {
            orderNumber: () => this.translate('thankYouPage.subtitle.orderNumber') /* Order number:  */,
            orderConfirmation: () => this.translate('thankYouPage.subtitle.orderConfirmation') /* You'll receive a confirmation email soon. */,
        },
        taxAmount: {
            defaultText: () => this.translate('thankYouPage.taxAmount.defaultText') /* 0.00 */,
        },
        subtotalAmount: {
            defaultText: () => this.translate('thankYouPage.subtotalAmount.defaultText') /* 10.00 */,
        },
        pickupAddress: {
            label: () => this.translate('thankYouPage.pickupAddress.label') /* Pickup address */,
        },
        discounts: {
            reason: {
                billingAdjustment: () => this.translate('thankYouPage.discounts.reason.billingAdjustment') /* Payment date change */,
                unspecified: () => this.translate('thankYouPage.discounts.reason.unspecified') /* Discount */,
                exchangedItems: () => this.translate('thankYouPage.discounts.reason.exchangedItems') /* Exchange credit */,
            },
        },
        pickup: {
            label: () => this.translate('thankYouPage.pickup.label') /* Pickup */,
        },
        quantity: {
            label: () => this.translate('thankYouPage.quantity.label') /* Qty: */,
        },
        deposit: {
            label: () => this.translate('thankYouPage.deposit.label') /* Deposit  */,
        },
        total: {
            label: () => this.translate('thankYouPage.total.label') /* Total */,
        },
        balanceDue: {
            label: () => this.translate('thankYouPage.balanceDue.label') /* Balance due  */,
        },
        title: {
            withName: (options: { name: any }) => this.translate('thankYouPage.title.withName', options) /* Thank you, {{name}} */,
            withoutName: () => this.translate('thankYouPage.title.withoutName') /* Thank you! */,
        },
        productOption1: {
            defaultText: () => this.translate('thankYouPage.productOption1.defaultText') /* Product option 1 */,
        },
        customerName: {
            defaultText: () => this.translate('thankYouPage.customerName.defaultText') /* Customer Name */,
        },
        customerNote: {
            previewText: () => this.translate('thankYouPage.customerNote.previewText') /* Your customer's note will show here.  */,
            label: () => this.translate('thankYouPage.customerNote.label') /* Note */,
        },
        giftCard: {
            label: () => this.translate('thankYouPage.giftCard.label') /* Gift card */,
        },
        tax: {
            label: () => this.translate('thankYouPage.tax.label') /* Tax */,
        },
        billingInfo: {
            label: () => this.translate('thankYouPage.billingInfo.label') /* Billing address */,
        },
        totalAmount: {
            defaultText: () => this.translate('thankYouPage.totalAmount.defaultText') /* 10.00 */,
        },
        vat: {
            label: () => this.translate('thankYouPage.vat.label') /* VAT */,
        },
        delivery: {
            label: () => this.translate('thankYouPage.delivery.label') /* Delivery */,
        },
        productOption3: {
            defaultText: () => this.translate('thankYouPage.productOption3.defaultText') /* Product option 3 */,
        },
        settingsTab: {
            image: {
                selection: () => this.translate('thankYouPage.settingsTab.image.selection') /* Image */,
            },
            continueBrowsing: {
                selection: () => this.translate('thankYouPage.settingsTab.continueBrowsing.selection') /* Continue Browsing Link */,
            },
            orderNumber: {
                selection: () => this.translate('thankYouPage.settingsTab.orderNumber.selection') /* Order Number */,
            },
        },
        back: {
            footerLink: () => this.translate('thankYouPage.back.footerLink') /* Back */,
        },
        productPrice: {
            defaultText: () => this.translate('thankYouPage.productPrice.defaultText') /* 10.00 */,
        },
        continueBrowsing: {
            footerLink: () => this.translate('thankYouPage.continueBrowsing.footerLink') /* Continue Browsing */,
        },
        productName: {
            defaultText: () => this.translate('thankYouPage.productName.defaultText') /* Product Name */,
        },
        subtotal: {
            label: () => this.translate('thankYouPage.subtotal.label') /* Subtotal */,
        },
        productOption2: {
            defaultText: () => this.translate('thankYouPage.productOption2.defaultText') /* Product option 2 */,
        },
        promoCode: {
            label: (options: { couponCode: any }) => this.translate('thankYouPage.promoCode.label', options) /* Promo code: {{couponCode}} */,
        },
        moreServices: {
            footerLink: () => this.translate('thankYouPage.moreServices.footerLink') /* Check Out More Services */,
        },
    };
    public thankYou = {
        TITLE_WITH_NAME: (options: { fullName: any }) => this.translate('thankYou.TITLE_WITH_NAME', options) /* Thank you for your order, {{fullName}}. */,
        DOWNLOAD_LINK_LABEL: () => this.translate('thankYou.DOWNLOAD_LINK_LABEL') /* Download */,
        STORE_PICKUP_TIME: (options: { deliveryTime: any }) => this.translate('thankYou.STORE_PICKUP_TIME', options) /* Ready for pickup: {{deliveryTime}} */,
        ORDER_NUMBER_LABEL: () => this.translate('thankYou.ORDER_NUMBER_LABEL') /* Order No: */,
        FOOTER_CONFIRMATION_TEXT: () => this.translate('thankYou.FOOTER_CONFIRMATION_TEXT') /* Keep an eye on your inbox - a confirmation email is on its way... */,
        TOTAL_LABEL: () => this.translate('thankYou.TOTAL_LABEL') /* Total: */,
        OFFLINE_PAYMENT_LABEL: () => this.translate('thankYou.OFFLINE_PAYMENT_LABEL') /* Offline Payment */,
        PENDING_ORDER_MESSAGE: (options: { buyerMail: any }) => this.translate('thankYou.PENDING_ORDER_MESSAGE', options) /* Your order is being processed.
We will notify you once it has been approved by email to {{buyerMail}}. */,
        DOWNLOAD_LINKS_ERROR: () => this.translate('thankYou.DOWNLOAD_LINKS_ERROR') /* Download links are currently not available. */,
        STORE_PICKUP_LABEL: () => this.translate('thankYou.STORE_PICKUP_LABEL') /* Pickup */,
        DELIVERY_ADDRESS: (options: { addressLine: any, city: any, state: any, zipCode: any, country: any }) => this.translate('thankYou.DELIVERY_ADDRESS', options) /* {{addressLine}}
{{city}}, {{state}} {{zipCode}}
{{country}} */,
        FOOTER_LINK: () => this.translate('thankYou.FOOTER_LINK') /* Continue Shopping */,
        DELIVERY_ADDRESS_FULL_INCLUDING_ADDRESS_LINE_2: (options: { fullName: any, company: any, addressLine: any, addressLine2: any, city: any, state: any, zipCode: any, country: any, phone: any }) => this.translate('thankYou.DELIVERY_ADDRESS_FULL_INCLUDING_ADDRESS_LINE_2', options) /* {{fullName}}
{{company}}
{{addressLine}}, {{addressLine2}}
{{city}}, {{state}} {{zipCode}}
{{country}}
{{phone}} */,
        FOOTER_DOWNLOADS_CONFIRMATION_TEXT: () => this.translate('thankYou.FOOTER_DOWNLOADS_CONFIRMATION_TEXT') /* Downloads available for 30 days. And keep an eye on your inbox - we have also sent them by email... */,
        TITLE: () => this.translate('thankYou.TITLE') /* Thank you for your order. */,
        SHIPPING_LABEL: () => this.translate('thankYou.SHIPPING_LABEL') /* Delivery to: */,
        LOADING_TITLE: () => this.translate('thankYou.LOADING_TITLE') /* Processing your payment... */,
        DOWNLOAD_LINKS_ERROR_CONTINUED: () => this.translate('thankYou.DOWNLOAD_LINKS_ERROR_CONTINUED') /* You’ll receive an email confirmation soon with the download links to your products. */,
        SUBTITLE: () => this.translate('thankYou.SUBTITLE') /* You'll receive an email confirmation soon. */,
        DELIVERY_ADDRESS_FULL: (options: { fullName: any, company: any, addressLine: any, city: any, state: any, zipCode: any, country: any, phone: any }) => this.translate('thankYou.DELIVERY_ADDRESS_FULL', options) /* {{fullName}}
{{company}}
{{addressLine}}
{{city}}, {{state}} {{zipCode}}
{{country}}
{{phone}} */,
        additionalFees: () => this.translate('thankYou.additionalFees') /* Additional fees:  */,
        DOWNLOAD_LINKS_LABEL: () => this.translate('thankYou.DOWNLOAD_LINKS_LABEL') /* Your Downloads: */,
    };
    public thank_you_page_plan_frequency_description_2_years_label = () => this.translate('thank_you_page_plan_frequency_description_2_years_label') /* every 2 years */;
    public thank_you_page_plan_frequency_description_year_singular_label = () => this.translate('thank_you_page_plan_frequency_description_year_singular_label') /* per year */;
    public THANK_YOU_PAGE_PLAN_MONTHS = () => this.translate('THANK_YOU_PAGE_PLAN_MONTHS') /* month */;
    public thankyouPage = {
        designTab: {
            borderColor: () => this.translate('thankyouPage.designTab.borderColor') /* Border opacity & color */,
            dividers: () => this.translate('thankyouPage.designTab.dividers') /* Dividers */,
            borderWidth: () => this.translate('thankyouPage.designTab.borderWidth') /* Border width (px) */,
            border: () => this.translate('thankyouPage.designTab.border') /* Border */,
            backgroundPicker: () => this.translate('thankyouPage.designTab.backgroundPicker') /* Background opacity & color */,
            titles: () => this.translate('thankyouPage.designTab.titles') /* Titles */,
            pageText: () => this.translate('thankyouPage.designTab.pageText') /* Body text */,
        },
        textTab: {
            titleTextLabel: () => this.translate('thankyouPage.textTab.titleTextLabel') /* Page title */,
            orderNumberLabel: () => this.translate('thankyouPage.textTab.orderNumberLabel') /* Order number label */,
            pageSubtitle: () => this.translate('thankyouPage.textTab.pageSubtitle') /* Page subtitle */,
            totalCostLabel: () => this.translate('thankyouPage.textTab.totalCostLabel') /* Total cost label */,
            continueShoppingPlaceholder: () => this.translate('thankyouPage.textTab.continueShoppingPlaceholder') /* Continue Browsing */,
            orderNumberDefaultText: () => this.translate('thankyouPage.textTab.orderNumberDefaultText') /* Order number: */,
            totalCostDefaultText: () => this.translate('thankyouPage.textTab.totalCostDefaultText') /* Total: */,
            shippingAddressLabel: () => this.translate('thankyouPage.textTab.shippingAddressLabel') /* Delivery address label */,
            subtitleDefaultText: () => this.translate('thankyouPage.textTab.subtitleDefaultText') /* You'll receive a confirmation email soon. */,
        },
        myCartPaymentMethod: {
            offlinePayment: {
                lineItem: () => this.translate('thankyouPage.myCartPaymentMethod.offlinePayment.lineItem') /* Pay in person */,
            },
            offlinePlan: {
                lineItemWithoutId: () => this.translate('thankyouPage.myCartPaymentMethod.offlinePlan.lineItemWithoutId') /* Pay later with a plan */,
                lineItemWithId: (options: { membership: any }) => this.translate('thankyouPage.myCartPaymentMethod.offlinePlan.lineItemWithId', options) /* Pay later with {{membership}} */,
            },
            onlinePlan: {
                lineItem: (options: { membership: any }) => this.translate('thankyouPage.myCartPaymentMethod.onlinePlan.lineItem', options) /* Pay with {{membership}} */,
            },
            payWithPlan: {
                lineItem: () => this.translate('thankyouPage.myCartPaymentMethod.payWithPlan.lineItem') /* Pay with a plan */,
            },
            deposit: {
                lineItem: (options: { price: any }) => this.translate('thankyouPage.myCartPaymentMethod.deposit.lineItem', options) /* Deposit: {{price}} */,
            },
        },
        extendedFields: {
            boolean: {
                true: () => this.translate('thankyouPage.extendedFields.boolean.true') /* Yes */,
                false: () => this.translate('thankyouPage.extendedFields.boolean.false') /* No */,
            },
        },
        menu: {
            upgradeTab: () => this.translate('thankyouPage.menu.upgradeTab') /* Upgrade */,
        },
    };
    public LIKE_YOUR_STYLE_TITLE = () => this.translate('LIKE_YOUR_STYLE_TITLE') /* HOPE TO SEE YOU AGAIN SOON. */;
    public thank_you_page_plan_frequency_description_months_plural_label = (options: { numberOfFrequencyUnits: any }) => this.translate('thank_you_page_plan_frequency_description_months_plural_label', options) /* every {{numberOfFrequencyUnits}} months */;
    public THANK_YOU_PAGE_PLAN_YEAR = () => this.translate('THANK_YOU_PAGE_PLAN_YEAR') /* year */;
    public thank_you_page_plan_frequency_description_days_plural_label = (options: { numberOfFrequencyUnits: any }) => this.translate('thank_you_page_plan_frequency_description_days_plural_label', options) /* every {{numberOfFrequencyUnits}} days */;
    public thank_you_page_plan_frequency_description_month_singular_label = () => this.translate('thank_you_page_plan_frequency_description_month_singular_label') /* per month */;
    public thank_you_page_plan_frequency_description_years_plural_label = (options: { numberOfFrequencyUnits: any }) => this.translate('thank_you_page_plan_frequency_description_years_plural_label', options) /* every {{numberOfFrequencyUnits}} years */;
    public THANK_YOU_PAGE_SUBSCRIPTION_PLAN_LABEL = () => this.translate('THANK_YOU_PAGE_SUBSCRIPTION_PLAN_LABEL') /* Subscription: */;
    public TOTAL_COST_TITLE = () => this.translate('TOTAL_COST_TITLE') /* Total cost: */;
    public THANK_YOU_PAGE_PLAN_WEEK = () => this.translate('THANK_YOU_PAGE_PLAN_WEEK') /* week */;
    public THANK_YOU_PAGE_PLAN_DURATION_DESCRIPTION_PLURAL = (options: { numberOfFrequencyUnits: any, frequencyUnitSingular: any }) => this.translate('THANK_YOU_PAGE_PLAN_DURATION_DESCRIPTION_PLURAL', options) /* {{numberOfFrequencyUnits}} {{frequencyUnitSingular}} subscription */;
    public thank_you_page_plan_frequency_description_2_weeks_label = () => this.translate('thank_you_page_plan_frequency_description_2_weeks_label') /* every 2 weeks */;
    public ORDER_NUMBER_TITLE = () => this.translate('ORDER_NUMBER_TITLE') /* Your order number: */;
    public THANK_YOU_PAGE_PLAN_WEEKS = () => this.translate('THANK_YOU_PAGE_PLAN_WEEKS') /* week */;
    public THANK_YOU_PAGE_PLAN_MONTH = () => this.translate('THANK_YOU_PAGE_PLAN_MONTH') /* month */;
    public THANK_YOU_PAGE_SUBSCRIPTION_TITLE = (options: { fullName: any }) => this.translate('THANK_YOU_PAGE_SUBSCRIPTION_TITLE', options) /* Thank you for subscribing, {{fullName}}! */;
    public thank_you_page_plan_frequency_description_2_day_label = () => this.translate('thank_you_page_plan_frequency_description_2_day_label') /* every 2 days */;
    public THANK_YOU_MSG_WITHOUT_NAME = () => this.translate('THANK_YOU_MSG_WITHOUT_NAME') /* THANKS FOR SHOPPING! */;
    public THANK_YOU_MSG = (options: { username: any }) => this.translate('THANK_YOU_MSG', options) /* THANKS FOR SHOPPING, {{username}}! */;
    public THANK_YOU_PAGE_PLAN_FREQUENCY_DESCRIPTION = (options: { price: any, frequencyUnitSingular: any }) => this.translate('THANK_YOU_PAGE_PLAN_FREQUENCY_DESCRIPTION', options) /* {{price}} / {{frequencyUnitSingular}} */;
    public SHIPPING_TO_TITLE = () => this.translate('SHIPPING_TO_TITLE') /* Delivery to: */;
    public THANK_YOU_PAGE_PLAN_DURATION_DESCRIPTION_AUTORENEW = () => this.translate('THANK_YOU_PAGE_PLAN_DURATION_DESCRIPTION_AUTORENEW') /* Auto-renew until canceled */;
    public SUMMARY_TITLE = () => this.translate('SUMMARY_TITLE') /* SUMMARY */;
    public thank_you_page_plan_frequency_description_2_months_label = () => this.translate('thank_you_page_plan_frequency_description_2_months_label') /* every 2 months */;
    public CONTINUE_SHOPPING_BUTTON = () => this.translate('CONTINUE_SHOPPING_BUTTON') /* Continue Shopping */;
    public THANK_YOU_PAGE_PLAN_YEARS = () => this.translate('THANK_YOU_PAGE_PLAN_YEARS') /* year */;
    public thank_you_page_plan_frequency_description_day_singular_label = () => this.translate('thank_you_page_plan_frequency_description_day_singular_label') /* per day */;
    public SEND_EMAIL_TEXT = () => this.translate('SEND_EMAIL_TEXT') /*   */;
    public SHIPPING_TO = (options: { city: any, state: any, zipCode: any, country: any }) => this.translate('SHIPPING_TO', options) /* {{city}}, {{state}} {{zipCode}}, {{country}} */;
    public thank_you_page_plan_frequency_description_weeks_plural_label = (options: { numberOfFrequencyUnits: any }) => this.translate('thank_you_page_plan_frequency_description_weeks_plural_label', options) /* every {{numberOfFrequencyUnits}} weeks */;
    public thank_you_page_plan_frequency_description_week_singular_label = () => this.translate('thank_you_page_plan_frequency_description_week_singular_label') /* per week */;
}
/* tslint:enable */
